export const BUILD_VERSION = '6125d8186c7dccef6be9807e6334da481a955531';
